import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";

interface Props {
	tagList: string[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const DepartureAirportComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const dataList = dataStr.replaceAll("|", "").split("^");

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id="outCityList0"
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value={"전체"}
				/>
				<label htmlFor="outCityList0">
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{dataList.map((value, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`outCityList${idx + 1}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.includes(value)}
						value={value}
					/>
					<label htmlFor={`outCityList${idx + 1}`}>
						<span>{value}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const DepartureAirport = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter DepartureAirport Error">
		<DepartureAirportComponent {...props} />
	</ErrorBoundary>
);

export default DepartureAirport;
